import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import WorkingGroupWidget from '../../../widgets/projectProposal/workingGroup/WorkingGroupWidget'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { getWorkingGroup } from '../../../redux/actions/workingGroup'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'

export default function WorkingGroup() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()
  const [showEditAll, setShowEditAll] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.monitoringAndInternalEvaluation}`,
    pathNameForward: `${pathname.proposal.projectManagementStructure}`,
  }

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getWorkingGroup(projectId)
      console.log('response 1111', response)
      setSchema(response)
      // setIsEditWidget({
      //   projectTeam: _schema.forms?.projectName?.id ? false : true,
      // })
      doCalculateEditWidget(response)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    projectId && handleGetSchema()
  }, [])

  const doCalculateEditWidget = (_schema) => {
    let editObj = {}
    let editAll = true
    _schema?.forms?.projectTeam?.model?.forEach((item, index) => {
      editObj[`projectTeam_${index}`] = item.id ? false : true
      editAll = editAll && !item.disabled
    })

    setIsEditWidget(editObj)
    setShowEditAll(editAll)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            routing={buttonRoute}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            editWidget={isEditWidget}
            forms={schema?.forms}
          />
        )}

        {schema?.forms?.projectTeam?.model && (
          <WorkingGroupWidget
            showCommandButton={!schema?.forms?.projectTeam?.disabled}
            schema={schema.forms.projectTeam.model}
            onDeleteSuccess={handleGetSchema}
            isEditWidget={isEditWidget}
            onChangeIsEdit={(key, _isEdit) => handleOnChangeIsEdit(key, _isEdit, setIsEditWidget)}
            setIsEditWidget={setIsEditWidget}
          />
        )}
      </SidebarProposal>
    </>
  )
}
